<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <div class="mt-2 tabName">
                <h3>{{ $t('edit_custom_medication') }}</h3>
            </div>
            <CustomMedicationForm
                :customMedication="customMedication"
                :edit="true"
                :key="formKey"
                submitButtonName="edit_custom_medication"
                @submit="submit"
            />
        </div>
    </div>
</template>

<script>
import Loading from '@/views/partial/Loading';
import { getCustomMedication, handleAxiosError, updateCustomMedication } from '@/services/axiosService';
import CustomMedicationForm from './CustomMedicationForm';

export default {
    components: {
        CustomMedicationForm,
        Loading
    },
    data() {
        return {
            error: {},
            customMedication: {},
            formKey: 0,
            loaded: false
        };
    },
    async created() {
        await this.getCustomMedication();
        this.loaded = true;
    },
    methods: {
        // get custom medication by vnr
        async getCustomMedication() {
            try {
                this.customMedication = await getCustomMedication(this.$route.params.vnr);
                // if med is not editable, show error and return to custom med index
                if (!this.customMedication.editable) {
                    this.$toastr.e(this.$t('custom_medication_cannot_edit_in_use'));
                    this.$router.push({ name: 'customMedications.index' });
                }
            } catch (error) {
                handleAxiosError(error);
                this.$router.push({ name: 'customMedications.index' });
            }
        },
        // submit: update custom med, show notification and redirect to index page
        async submit() {
            try {
                await updateCustomMedication(this.customMedication);
                this.$toastr.s(this.$t('custom_medication_updated'));
                this.$router.push({ name: 'customMedications.index' });
            } catch (error) {
                handleAxiosError(error);
                this.formKey = this.formKey + 1;
            }
        }
    }
};
</script>
